import React from 'react';
import { MapPin, Users, Heart } from 'lucide-react';

const CommunityInfo = () => {
  const barangays = [
    { name: 'Tagabinet', coverage: 'Almost 10%' },
    { name: 'Cabayugan', coverage: '70%' },
    { name: 'Marufinas', coverage: '100%' },
    { name: 'New Panggangan', coverage: 'Buffer Zone' }
  ];

  const ipOrganizations = [
    { name: 'Marufinas Tribal Association', location: 'Barangay Marufinas' },
    { name: 'Tinig ng mga Katutubo sa Cabayugan (TICKA)', location: 'Barangay Cabayugan' },
    { name: 'Samahang Tribu sa Kayasan (SATRIKA)', location: 'Barangay Tagabinet' }
  ];

  return (
    <section className="py-16 bg-[var(--color-background)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[var(--color-primary)] dark:text-[var(--color-tertiary)] mb-4">
            PPSRNP Community
          </h2>
          <p className="text-lg text-gray-800 dark:text-gray-200 max-w-3xl mx-auto">
            The heart of PPSRNP lies in its vibrant communities and indigenous peoples who are the true guardians of this natural treasure.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Barangays Section */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8 border border-[var(--color-border)]">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-full bg-[var(--color-primary)]/10 dark:bg-[var(--color-tertiary)]/10 flex items-center justify-center">
                <MapPin className="w-7 h-7 text-[var(--color-primary)] dark:text-[var(--color-tertiary)]" />
              </div>
              <h3 className="text-2xl font-bold text-[var(--color-primary)] dark:text-[var(--color-tertiary)]">
                Barangays
              </h3>
            </div>

            <p className="text-gray-800 dark:text-gray-200 mb-6 leading-relaxed">
              The Puerto Princesa Subterranean River National Park encompasses four rural barangays namely Tagabinet (almost 10%), Cabayugan (70%), Marufinas (100%) and New Panggangan as a buffer. The four barangays are situated in the western coast of Palawan mainland and within the administrative jurisdiction of the Highly-Urbanized City of Puerto Princesa.
            </p>

            <div className="space-y-3">
              {barangays?.map((barangay, idx) => (
                <div
                  key={idx}
                  className="flex items-center justify-between p-4 bg-[var(--color-card)] dark:bg-gray-700 rounded-lg"
                >
                  <span className="font-semibold text-[var(--color-primary)] dark:text-[var(--color-tertiary)]">
                    {barangay?.name}
                  </span>
                  <span className="text-sm px-3 py-1 bg-[var(--color-accent)]/20 text-[var(--color-accent)] dark:text-[var(--color-tertiary)] rounded-full">
                    {barangay?.coverage}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Indigenous Peoples Section */}
          <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8 border border-[var(--color-border)]">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-14 h-14 rounded-full bg-[var(--color-secondary)]/10 dark:bg-[var(--color-tertiary)]/10 flex items-center justify-center">
                <Users className="w-7 h-7 text-[var(--color-secondary)] dark:text-[var(--color-tertiary)]" />
              </div>
              <h3 className="text-2xl font-bold text-[var(--color-primary)] dark:text-[var(--color-tertiary)]">
                Indigenous Peoples
              </h3>
            </div>

            <p className="text-gray-800 dark:text-gray-200 mb-4 leading-relaxed">
              The Indigenous People within and around the Puerto Princesa Subterranean River National Park are primarily from the Tagbanua and Batak groups, whose lives and culture are connected to the park's natural environment.
            </p>

            <p className="text-gray-800 dark:text-gray-200 mb-6 leading-relaxed">
              The park encompasses three (3) ancestral domain lands, showing the long-standing presence of Indigenous communities in the area. Most Indigenous households depend on agriculture and tourism as the main sources of their livelihood, allowing them to support their family.
            </p>

            <div className="bg-[var(--color-card)] dark:bg-gray-700 rounded-lg p-4 mb-4">
              <div className="flex items-center gap-2 mb-3">
                <Heart className="w-5 h-5 text-[var(--color-accent)] dark:text-[var(--color-tertiary)]" />
                <h4 className="font-semibold text-[var(--color-primary)] dark:text-[var(--color-tertiary)]">
                  Partner Organizations
                </h4>
              </div>
              <p className="text-sm text-gray-700 dark:text-gray-300 mb-3">
                The park maintains strong relationships with Indigenous People within the protected area through partner organizations:
              </p>
              <ul className="space-y-2">
                {ipOrganizations?.map((org, idx) => (
                  <li key={idx} className="text-sm">
                    <span className="font-semibold text-[var(--color-primary)] dark:text-[var(--color-tertiary)]">
                      {org?.name}
                    </span>
                    <span className="text-gray-700 dark:text-gray-300"> - {org?.location}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityInfo;